import { render, staticRenderFns } from "./NewSignUpCard.vue?vue&type=template&id=d9c53ef2&scoped=true"
import script from "./NewSignUpCard.vue?vue&type=script&lang=js"
export * from "./NewSignUpCard.vue?vue&type=script&lang=js"
import style0 from "./NewSignUpCard.vue?vue&type=style&index=0&id=d9c53ef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c53ef2",
  null
  
)

export default component.exports